import _extends from 'babel-runtime/helpers/extends';

import _ from 'lodash';
import DialogForm from '@/components/DialogForm/index.vue';
import { updateCreativeInfo, createCreativeInfo } from '@/api/creative/info';
import { fetchAppInfoList } from '@/api/system/app';
import { categories } from '@/common/material-metadata';

export default {
  components: {
    DialogForm: DialogForm
  },
  props: {
    dialogConfig: Object,
    dialogValue: Object,
    creationType: Number,
    successCallback: Function,
    demand: Object
  },
  data: function data() {
    return {
      appOptions: []
    };
  },

  computed: {
    inlineItemList: function inlineItemList() {
      var itemList = [{
        visible: !this.dialogValue.id,
        label: '请选择创意类型',
        type: 'select',
        prop: 'material_type',
        rules: [{
          required: true,
          message: '请选择创意类型',
          trigger: 'change'
        }],
        params: {
          placeholder: '请选择创意类型',
          options: categories,
          style: 'width:100%'
        }
      }, {
        label: '请输入创意方向',
        type: 'input',
        prop: 'name',
        params: {
          placeholder: '请输入创意方向',
          maxLength: 100
        },
        rules: [{
          required: true,
          message: '请输入创意方向',
          trigger: 'blur'
        }, {
          min: 1,
          max: 100,
          message: '创意方向不能超过 100 个字符',
          trigger: 'blur'
        }]
      }, {
        visible: !this.dialogValue.id,
        label: '是否通过代码字实现：',
        type: 'radio-group',
        prop: 'enable_i18n',
        rules: [{ required: true, message: '是否通过代码字实现是必填项' }],
        params: {
          options: [{
            label: '是',
            value: 1
          }, {
            label: '否',
            value: 2
          }]
        }
      }];
      return itemList;
    }
  },
  watch: {
    'dialogValue.app_id': function dialogValueApp_id(val) {
      if (val) {
        // eslint-disable-next-line vue/no-mutating-props
        this.dialogValue.name = this.appOptions.find(function (e) {
          return e.value === val;
        }).label;
      } else {
        // eslint-disable-next-line vue/no-mutating-props
        this.dialogValue.name = '';
      }
    },
    'dialogConfig.visible': function dialogConfigVisible(val) {
      if (val) {
        if (!this.appOptions.length) {
          this.remoteAppData('');
        }
      } else {
        this.resetFields();
      }
    }
  },
  methods: {
    remoteAppData: function remoteAppData(query) {
      var _this = this;

      fetchAppInfoList({
        page: 1,
        page_size: 15,
        search_field: 'name',
        keyword: query
      }).then(function (res) {
        _this.appOptions = res.data.data.list.map(function (item) {
          return _extends({}, item, {
            value: item.id,
            label: item.name
          });
        });
      }).catch(function () {
        _this.appOptions = [];
      });
    },
    submitDialogForm: function submitDialogForm() {
      var _this2 = this;

      // eslint-disable-next-line vue/no-mutating-props
      this.dialogConfig.loading = true;
      var postPromise = createCreativeInfo;
      var postData = {
        name: this.dialogValue.name,
        material_type: this.dialogValue.material_type,
        enable_i18n: this.dialogValue.enable_i18n,
        adv_id: this.demand ? this.demand.adv_id : ''
        // 存在id说明是编辑操作
      };if (this.dialogValue.id) {
        postPromise = updateCreativeInfo;
        postData = _.omit(postData, ['material_type']);
        postData.id = this.dialogValue.id;
      }
      postPromise(postData).then(function (res) {
        // eslint-disable-next-line vue/no-mutating-props
        _this2.dialogConfig.loading = false;
        // eslint-disable-next-line vue/no-mutating-props
        _this2.dialogConfig.visible = false;
        _this2.$message({
          message: 'success',
          type: 'success'
        });
        var creativeData = _.get(res, 'data.data.info') || {};
        _this2.successCallback && _this2.successCallback(creativeData);
      }).catch(function () {
        // eslint-disable-next-line vue/no-mutating-props
        _this2.dialogConfig.loading = false;
      });
    },
    resetFields: function resetFields() {
      console.log(this.$refs.form);
      return this.$refs.form.resetFields();
    }
  }
};